import { computed, Directive, input } from '@angular/core';

/**
 * Turns a `fr8bot-ui-table-header-row` into the table's filter row: hidden until `filterRowOpen`,
 * gray, borderless and at least 70px tall. Its cells take `fr8botUiTableFilterCell`. A transparent
 * 4px left border matches the one the header and data rows carry, so the filters stay level with
 * their columns.
 */
@Directive({
  selector: 'fr8bot-ui-table-header-row[fr8botUiTableFilterRow]',
  host: { '[class]': 'hostClass()' },
})
export class TableFilterRowUIDirective {
  readonly filterRowOpen = input(false);

  protected readonly hostClass = computed(
    () =>
      `tw:min-h-[70px] tw:border-0 tw:border-l-4 tw:border-l-transparent tw:bg-gray-7 ${this.filterRowOpen() ? '' : 'tw:hidden'}`,
  );
}
